// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeRoundNudgeEntryBody = {
  poolId: string;
  roundId: string;
  entryId: string;
};

export type typeRoundNudgeEntryOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { sentToUserId: string; nudgedAtIso: string };
};

export type typeRoundNudgeEntryOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundNudgeEntryOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundNudgeEntryOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaRoundNudgeEntryBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    entryId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "roundId", "entryId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createRoundNudgeEntry(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaRoundNudgeEntryBody);
  }

  return async function postRoundNudgeEntry(
    payload: typeRoundNudgeEntryBody,
  ): Promise<typeRoundNudgeEntryOutput200 | typeRoundNudgeEntryOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postRoundNudgeEntry" failed before calling the network. #a83220862a78`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a83220862a78" },
        },
        data: null,
      } as typeRoundNudgeEntryOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/round/nudge-entry`,
      httpMethod: "POST",
      options,
    })) as typeRoundNudgeEntryOutput200 | typeRoundNudgeEntryOutput400;
  };
}
